import Layout from "../../components/shared/layout/layout";
import Blog from "../../components/blog/blog";
import Link from "next/link";
import {useRouter} from "next/router";
import styles from "../../components/blog/blog.module.css";
import {useEffect, useState} from "react";
import Seo from "../../components/shared/seo/seo";
import { resolveImageUrl } from "../../lib/imageUrl";


function showBlogPopup(id) {
    
    let blog = document.getElementById(`blogPopup-${id}`);
    if(blog != null && blog.classList != null)
        blog.classList.add(styles.show);
    
}

export default function Weinblog(){
    const router = useRouter();
    const id = router.query.id;
    if(id != undefined && id != null) {
        showBlogPopup(id);
    }

    const [blogs, setBlogs] = useState(null);
    useEffect(() =>{
        if(blogs == null){
            getBlogs().then((data)=> setBlogs(data));
        }
    }, [blogs]);

    function initBlogs(blogs) {
        const elements=[];
        for (let i = 0; i < blogs.length; i++) {
            const blog = blogs[i];
            
            elements.push(
                <Blog key={blog.blogId} id={blog.blogId} date={new Date(blog.created).getFullYear()}
                      image={resolveImageUrl(blog.imageLocation, 'blog')}
                      thumb={resolveImageUrl(blog.thumbnailLocation, 'blog')}
                      title={blog.title} subtitle={blog.subTitle} content={blog.content}
                      moreTitle={blog.moreTitle}
                      moreContent={blog.moreContent}
                      shopProductId={blog.productHeaderId ?? blog.productHeader?.productHeaderId}
                      shopProductText={blog.productText}/>
            );
        }
        return elements;
    }
    function getBlogs(){
        return fetch("https://api.gisperg.wine/api/Blog/All",{
            method:'GET',
            mode: 'cors'
        }).then((res)=> res.json());
    }



    return(
        <Layout>
            <Seo
                title="Weinblog"
                description="Geschichten, Verkostungsnotizen und Einblicke aus dem Weingut Gisperg."
                path="/news/weinblog"
            />
            <section className="background_light_texture no_fill small">
                <Link href="/news">
                    <p className="marker-back goBack annotation white"><b>Zurück</b></p>
                </Link>
                <h1 className="white center-text">Wein Blog</h1>
            </section>
            <section className="background_light">
                <div className="col-12" style={{marginBottom:"100px"}}>
                    <p className="brown phrase">Entdecken Sie exklusive Inhalte und noch vieles mehr:</p>
                </div>
                <div className="wrap-box">
                    {blogs != null && initBlogs(blogs)}
                </div>
            </section>
        </Layout>
    )
}